<button nz-button nzType="text" nzSize="small" (click)="onClick()" nz-tooltip [nzTooltipTitle]="tooltip">
  <span nz-icon style="font-size: 16px" class="material-symbols-rounded">content_copy</span>
</button>
